var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OfflineDataManager } from './OfflineDataManager';
import { UserInfo } from './model/UserInfo';
import { getUserId } from './tools/utils';
import { FILE_TYPE } from './model/PadInfo';
import Log from './tools/Log';
import { QueryCondition, QUERY_CONDITION_TYPE, IorderType, isNoResultError, } from '@tencent/tdoc-database';
import { TableName } from './Constant';
import { OFFLINE_ITEM_TYPE } from './model/OfflineData';
var DATA_TYPE;
(function (DATA_TYPE) {
    DATA_TYPE["SNAP_SHOT"] = "SNAP_SHOT";
    DATA_TYPE["CHUNK"] = "CHUNK";
    DATA_TYPE["VERSION_DATA"] = "VERSION_DATA";
})(DATA_TYPE || (DATA_TYPE = {}));
var EMPTY_CHUNK_DATA = {
    data: {
        startRow: -1,
        endRow: -1,
        data: [[]],
    },
};
/**
 * 离线相关API
 */
var OfflineAPI = /** @class */ (function () {
    function OfflineAPI() {
    }
    OfflineAPI.getDatabaseInstance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offlineDataManager, initResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.dbInstance) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        offlineDataManager = new OfflineDataManager({
                            businessType: FILE_TYPE.EXCEL, user: new UserInfo({
                                uid: this.uid,
                            }),
                        });
                        return [4 /*yield*/, offlineDataManager.init()];
                    case 2:
                        initResult = _a.sent();
                        if (initResult.error) {
                            Log.error('getDatabaseInstance() init error', initResult.error);
                            this._offlineDataManager = null;
                            this.dbInstance = null;
                            return [2 /*return*/, null];
                        }
                        this._offlineDataManager = offlineDataManager;
                        this.dbInstance = offlineDataManager.database;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        Log.error('getDatabaseInstance', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, this.dbInstance];
                }
            });
        });
    };
    Object.defineProperty(OfflineAPI, "offlineDataManager", {
        get: function () {
            return OfflineAPI._offlineDataManager || null;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param id
     * @param subId
     * @param callback
     */
    OfflineAPI.loadDocumentData = function (options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var startTime, id, subId, onSuccess, onFail, databaseInstance, condition, documentQueryResult, documentInfo, loadDocumentFinishTime, filterSubIdResult, clientVars, rev, workbookData, subDocumentData, versionDataCondition, maxVersionDataResult, maxVersion, documentDataCondition, documentDataQueryResult, loadDocumentDataFinishTime, firstRenderFinishTime, otherSubDocumentDataCondition, otherSubDocumentDataQueryResult, otherSubDocumentData, breakVersionsDataCondition, breakVersionsDataResult, breakVersionData, breakVersionChunkData, loadBreakVersionFinishTime;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        startTime = Date.now();
                        id = options.id, subId = options.subId, onSuccess = options.onSuccess, onFail = options.onFail;
                        return [4 /*yield*/, this.getDatabaseInstance()];
                    case 1:
                        databaseInstance = (_c.sent());
                        condition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.DOCUMENT, 'ducument']) /** 兼容下拼写错误的情况 */
                            // .addCondition('default', QUERY_CONDITION_TYPE.ONLY, true)
                            .orderby('version', IorderType.DECREASE) //  可能存在多个  取版本号最大的一个吧
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id);
                        return [4 /*yield*/, databaseInstance.get(TableName.DOCUMENT_DATA, condition)];
                    case 2:
                        documentQueryResult = _c.sent();
                        if (documentQueryResult.error) {
                            // Log.error('获取document信息失败', documentQueryResult.error);
                            onFail && onFail(new Error("\u83B7\u53D6document\u4FE1\u606F\u5931\u8D25 " + documentQueryResult.error));
                            return [2 /*return*/];
                        }
                        documentInfo = documentQueryResult.data;
                        loadDocumentFinishTime = Date.now();
                        filterSubIdResult = subId && documentInfo && documentInfo.data && documentInfo.data.collab_client_vars.header[0].d.filter(function (item) { return item.id === subId; }) || [];
                        // 如果subId没有传或者clientVars的headers里面没有这个subid 那就用clientVars里面的第一个subid
                        if (!subId || filterSubIdResult.length === 0) {
                            subId = documentInfo && documentInfo.data && documentInfo.data.collab_client_vars.header[0].d[0].id || ''; // todo 待完善
                        }
                        clientVars = documentInfo.data;
                        clientVars.collab_client_vars.padSubId = subId; // 更新clientVars里面表示当前子表的字段
                        rev = clientVars.collab_client_vars.rev || 0;
                        if (!(clientVars.padStatus !== 'new')) return [3 /*break*/, 5];
                        versionDataCondition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.ACCEPTED, OFFLINE_ITEM_TYPE.MISS_CHANGE, OFFLINE_ITEM_TYPE.NEW_CHANGE])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            // .addCondition('version', QUERY_CONDITION_TYPE.LOWER_BOUND, { lower: rev, open: true })  // 理论上这里要加上这个限制，但是android客户端这边目前实现有问题，version是数字但是按字符串去做对比就会查不出来数据
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id)
                            .orderby('version', IorderType.DECREASE)
                            .limit(0, 1);
                        return [4 /*yield*/, databaseInstance.get(TableName.DOCUMENT_DATA, versionDataCondition)];
                    case 3:
                        maxVersionDataResult = _c.sent();
                        if (maxVersionDataResult.error && !isNoResultError(maxVersionDataResult.error)) {
                            Log.error('获取增量版本数据失败', maxVersionDataResult.error);
                            onFail && onFail(new Error("\u83B7\u53D6\u589E\u91CF\u7248\u672C\u6570\u636E\u9519\u8BEF"));
                            return [2 /*return*/];
                        }
                        else if (!maxVersionDataResult.error && maxVersionDataResult.data) {
                            maxVersion = Math.max(rev, maxVersionDataResult.data.version);
                            // 修改clientVars中的rev
                            clientVars.collab_client_vars.rev = maxVersion;
                        }
                        documentDataCondition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.WORKBOOK, OFFLINE_ITEM_TYPE.CHUNK])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('subSheetId', QUERY_CONDITION_TYPE.IN, ['workbook', subId])
                            .addCondition('chunkId', QUERY_CONDITION_TYPE.ONLY, 0) // 只读取首片
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id);
                        return [4 /*yield*/, databaseInstance.getAll(TableName.DOCUMENT_DATA, documentDataCondition)];
                    case 4:
                        documentDataQueryResult = _c.sent();
                        if (documentDataQueryResult.error) {
                            // Log.error('获取documentData信息失败', documentDataQueryResult.error);
                            onFail && onFail(new Error("\u83B7\u53D6documentData\u4FE1\u606F\u5931\u8D25 " + documentDataQueryResult.error));
                            return [2 /*return*/];
                        }
                        workbookData = documentDataQueryResult.data.filter(function (item) { return item.type === 'workbook'; })[0];
                        subDocumentData = documentDataQueryResult.data.filter(function (item) { return item.type === 'chunk'; })[0];
                        _c.label = 5;
                    case 5:
                        if (!subDocumentData || ((_a = subDocumentData.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                            // 本地新建的文档 没有子表数据 要从clientVars里面拿
                            subDocumentData = {
                                data: {
                                    startRow: 0,
                                    endRow: 200,
                                    data: (_b = clientVars.collab_client_vars) === null || _b === void 0 ? void 0 : _b.initialAttributedText.text[0],
                                },
                            };
                        }
                        loadDocumentDataFinishTime = Date.now();
                        Log.log("\u6570\u636E\u52A0\u8F7D\u5B8C\u6210. document:" + (loadDocumentFinishTime - startTime) + "ms  workbook&subDocument: " + (loadDocumentDataFinishTime - loadDocumentFinishTime) + "ms");
                        onSuccess && onSuccess({
                            dataType: DATA_TYPE.SNAP_SHOT,
                            subId: subId,
                            clientVars: clientVars,
                            workbookData: workbookData && workbookData.data || EMPTY_CHUNK_DATA.data,
                            chunkData: subDocumentData && subDocumentData.data || EMPTY_CHUNK_DATA.data,
                        });
                        firstRenderFinishTime = Date.now();
                        Log.log("\u9996\u5C4F\u6570\u636E\u6E32\u67D3\u5B8C\u6210:" + (firstRenderFinishTime - startTime) + "ms");
                        otherSubDocumentDataCondition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.ONLY, OFFLINE_ITEM_TYPE.CHUNK)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('subSheetId', QUERY_CONDITION_TYPE.ONLY, subId)
                            .addCondition('version', QUERY_CONDITION_TYPE.ONLY, rev)
                            // .addCondition('chunkId', QUERY_CONDITION_TYPE.LOWER_BOUND, { lower: 1, open: false })  // 读取其他片 // 理论上这里要加上这个限制，但是android客户端这边目前实现有问题，数字按字符串去做对比就会查不出来数据
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id)
                            .orderby('chunkId', IorderType.INCREASE);
                        return [4 /*yield*/, databaseInstance.getAll(TableName.DOCUMENT_DATA, otherSubDocumentDataCondition)];
                    case 6:
                        otherSubDocumentDataQueryResult = _c.sent();
                        if (otherSubDocumentDataQueryResult.error) {
                            // Log.error('获取otherSubDocumentData信息失败', otherSubDocumentDataQueryResult.error);
                            onFail && onFail(new Error("\u83B7\u53D6otherSubDocumentData\u4FE1\u606F\u5931\u8D25 " + otherSubDocumentDataQueryResult.error));
                            return [2 /*return*/];
                        }
                        otherSubDocumentData = otherSubDocumentDataQueryResult.data;
                        otherSubDocumentData.filter(function (item) {
                            return item.chunkId >= 1; // 补丁逻辑 android客户端这边目前实现有问题，chunkId是数字但是按字符串去做对比就会查不出来数据 所以只能全部查出来再对比
                        })
                            .forEach(function (item) {
                            onSuccess && onSuccess({
                                subId: subId,
                                dataType: DATA_TYPE.CHUNK,
                                chunkData: item.data,
                            });
                        });
                        breakVersionsDataCondition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.ACCEPTED, OFFLINE_ITEM_TYPE.MISS_CHANGE, OFFLINE_ITEM_TYPE.NEW_CHANGE])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id)
                            // .addCondition('version', QUERY_CONDITION_TYPE.LOWER_BOUND, { lower: rev, open: true })// 理论上这里要加上这个限制，但是android客户端这边目前实现有问题，version是数字但是按字符串去做对比就会查不出来数据
                            .orderby('version', IorderType.INCREASE);
                        return [4 /*yield*/, databaseInstance.getAll(TableName.DOCUMENT_DATA, breakVersionsDataCondition)];
                    case 7:
                        breakVersionsDataResult = _c.sent();
                        if (breakVersionsDataResult.error) {
                            // Log.error('获取breakVersionData信息失败', breakVersionsDataResult.error);
                            onFail && onFail(new Error("\u83B7\u53D6breakVersionData\u4FE1\u606F\u5931\u8D25 " + breakVersionsDataResult.error));
                            return [2 /*return*/];
                        }
                        breakVersionData = breakVersionsDataResult.data;
                        breakVersionChunkData = breakVersionData
                            .map(function (item) { return _this.breakVersionDataParse(item); })
                            .filter(function (item) { return item.version > rev; }) // 补丁逻辑 android客户端这边目前实现有问题，version是数字但是按字符串去做对比就会查不出来数据 所以只能全部查出来再对比
                            .sort(function (item1, item2) {
                            return item1.version - item2.version;
                        });
                        onSuccess && onSuccess({
                            subId: subId,
                            dataType: DATA_TYPE.VERSION_DATA,
                            chunkData: breakVersionChunkData,
                            isFinished: true,
                        });
                        loadBreakVersionFinishTime = Date.now();
                        Log.log("\u6240\u6709\u5206\u7247\u6E32\u67D3\u5B8C\u6210:" + (Date.now() - startTime) + "ms   breakVersion: " + (loadBreakVersionFinishTime - firstRenderFinishTime) + "ms");
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 加载指定文档缺失的版本号数据
     * @param id 文档id
     * @param from 起始版本号 闭区间
     * @param to 目标版本号 闭区间
     */
    OfflineAPI.loadBreakVersions = function (id, from, to) {
        return __awaiter(this, void 0, void 0, function () {
            var databaseInstance, breakVersionsDataCondition, breakVersionsDataResult, breakVersionData, documentBreakVersions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.time('loadBreakVersions');
                        return [4 /*yield*/, this.getDatabaseInstance()];
                    case 1:
                        databaseInstance = (_a.sent());
                        breakVersionsDataCondition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.ACCEPTED, OFFLINE_ITEM_TYPE.MISS_CHANGE, OFFLINE_ITEM_TYPE.NEW_CHANGE])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id)
                            // .addCondition('version', QUERY_CONDITION_TYPE.LOWER_BOUND, { lower: from, open: false }) // 理论上这里要加上这个限制，但是android客户端这边目前实现有问题，version是数字但是按字符串去做对比就会查不出来数据
                            .orderby('version', IorderType.INCREASE);
                        return [4 /*yield*/, databaseInstance.getAll(TableName.DOCUMENT_DATA, breakVersionsDataCondition)];
                    case 2:
                        breakVersionsDataResult = _a.sent();
                        if (breakVersionsDataResult.error) {
                            // Log.error('获取breakVersionData信息失败', breakVersionsDataResult.error);
                            Promise.reject(new Error("\u83B7\u53D6breakVersionData\u4FE1\u606F\u5931\u8D25 " + breakVersionsDataResult.error));
                            return [2 /*return*/];
                        }
                        breakVersionData = breakVersionsDataResult.data;
                        documentBreakVersions = breakVersionData.map(function (item) { return _this.breakVersionDataParse(item); })
                            .filter(function (item) { return item.version >= from && (to === undefined || item.version <= to); });
                        console.timeEnd('loadBreakVersions');
                        return [2 /*return*/, Promise.resolve(documentBreakVersions)];
                }
            });
        });
    };
    /**
     * 加载指定文档的子表数据
     * @param id 文档id
     * @param subId 子表id
     * @param baseVersion 版本号
     */
    OfflineAPI.loadSubDocumentData = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var startTime, id, subId, baseVersion, onSuccess, onFail, databaseInstance, checkCondition, checkResult, maxVersion, subDocumentDataCondition, subDocumentDataQueryResult, subDocumentData, chunkDatas, maxChunkVersion, checkDocumentCondition, checkDocumentResult, loadSubDocumentDataFinishTime, renderSubDocumentDatFinishTime, breakVersionsDataCondition, breakVersionsDataResult, breakVersionData, documentBreakVersions, subDocumentBreakVersionLoadFinishTime;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = Date.now();
                        id = options.id, subId = options.subId, baseVersion = options.baseVersion, onSuccess = options.onSuccess, onFail = options.onFail;
                        if (id === undefined || subId === undefined || baseVersion === undefined) {
                            onFail && onFail(new Error("loadSubDocumentData\u53C2\u6570\u9519\u8BEF" + JSON.stringify(options)));
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getDatabaseInstance()];
                    case 1:
                        databaseInstance = (_a.sent());
                        checkCondition = QueryCondition.newInstance()
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id)
                            .orderby('version', IorderType.DECREASE)
                            .limit(0, 1);
                        return [4 /*yield*/, databaseInstance.get(TableName.DOCUMENT_DATA, checkCondition)];
                    case 2:
                        checkResult = _a.sent();
                        if (checkResult.error) {
                            onFail && onFail(new Error("\u83B7\u53D6\u6587\u6863\u6700\u5927\u672C\u5730\u7F13\u5B58\u7248\u672C\u53F7\u9519\u8BEF " + checkResult.error));
                            return [2 /*return*/];
                        }
                        maxVersion = checkResult.data.version;
                        if (maxVersion < baseVersion) {
                            onFail && onFail(new Error("\u672C\u5730\u7F13\u5B58\u7684\u6570\u636E\u7248\u672C\u53F7\u5C0F\u4E8E" + baseVersion + " \u6CA1\u529E\u6CD5\u8FD4\u56DE\u6240\u9700\u7684\u6570\u636E\u3002 maxVersion=" + maxVersion));
                            return [2 /*return*/];
                        }
                        subDocumentDataCondition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.ONLY, OFFLINE_ITEM_TYPE.CHUNK)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('subSheetId', QUERY_CONDITION_TYPE.ONLY, subId)
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id)
                            // .addCondition('version', QUERY_CONDITION_TYPE.UPPER_BOUND, { upper: baseVersion, open: false }) // 理论上这里要加上这个限制，但是android客户端这边目前实现有问题，version是数字但是按字符串去做对比就会查不出来数据
                            .orderby('chunkId', IorderType.INCREASE);
                        return [4 /*yield*/, databaseInstance.getAll(TableName.DOCUMENT_DATA, subDocumentDataCondition)];
                    case 3:
                        subDocumentDataQueryResult = _a.sent();
                        if (subDocumentDataQueryResult.error) {
                            // Log.error('获取subDocumentData信息失败', subDocumentDataQueryResult.error);
                            onFail && onFail(new Error("\u83B7\u53D6subDocumentData\u4FE1\u606F\u5931\u8D25 " + subDocumentDataQueryResult.error));
                            return [2 /*return*/];
                        }
                        subDocumentData = subDocumentDataQueryResult.data;
                        chunkDatas = [];
                        maxChunkVersion = 0;
                        subDocumentData
                            .filter(function (item) { return item.version <= baseVersion; }) // 补丁逻辑 android客户端这边目前实现有问题，version是数字但是按字符串去做对比就会查不出来数据 所以只能全部查出来再对比
                            .forEach(function (item) {
                            chunkDatas.push(item);
                            maxChunkVersion = Math.max(maxChunkVersion, item.version);
                        });
                        chunkDatas = chunkDatas.filter(function (item) { return item.version === maxChunkVersion; }); // 理论上所有chunk的版本是一致的 但是如果出现版本不一致  那就只能取全部是最大版本的这一套数据了 可能有多套缓存（这应该是bug，但是还是兜一下底）
                        if (!(chunkDatas.length === 0)) return [3 /*break*/, 5];
                        checkDocumentCondition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.DOCUMENT, 'ducument']) /**兼容下拼写错误的情况 */
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id);
                        return [4 /*yield*/, databaseInstance.get(TableName.DOCUMENT_DATA, checkDocumentCondition)];
                    case 4:
                        checkDocumentResult = _a.sent();
                        if (checkDocumentResult.error) {
                            // 无论是读取出错还是说没有数据都走失败
                            onFail && onFail(new Error("\u68C0\u9A8C\u662F\u5426\u672C\u5730\u6709\u8BE5\u6587\u6863\u7F13\u5B58\u5931\u8D25 " + checkDocumentResult.error));
                            return [2 /*return*/];
                        }
                        // 本地有缓存 但是没有chunk 这种情况可能就是本地新建子表的情况 可以返回一个空的chunk当keyframe
                        chunkDatas = [EMPTY_CHUNK_DATA];
                        _a.label = 5;
                    case 5:
                        loadSubDocumentDataFinishTime = Date.now();
                        Log.log("\u5B50\u8868\u4E3Bkeyfrme\u6570\u636E\u8BFB\u53D6\u5B8C\u6210:" + (loadSubDocumentDataFinishTime - startTime) + "ms");
                        onSuccess && onSuccess({
                            dataType: DATA_TYPE.SNAP_SHOT,
                            subId: subId,
                            chunkData: chunkDatas,
                        });
                        renderSubDocumentDatFinishTime = Date.now();
                        Log.log("\u5B50\u8868keyframe\u6E32\u67D3\u8017\u65F6:" + (renderSubDocumentDatFinishTime - loadSubDocumentDataFinishTime) + "ms");
                        breakVersionsDataCondition = QueryCondition.newInstance()
                            .addCondition('type', QUERY_CONDITION_TYPE.IN, [OFFLINE_ITEM_TYPE.ACCEPTED, OFFLINE_ITEM_TYPE.MISS_CHANGE, OFFLINE_ITEM_TYPE.NEW_CHANGE])
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, this.uid)
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, id)
                            .addCondition('subSheetId', QUERY_CONDITION_TYPE.ONLY, subId)
                            // .addCondition('version', QUERY_CONDITION_TYPE.BOUND, { lower: maxChunkVersion, open: true, upper: baseVersion, upperOpen: false }) // 理论上这里要加上这个限制，但是android客户端这边目前实现有问题，version是数字但是按字符串去做对比就会查不出来数据
                            .orderby('version', IorderType.INCREASE);
                        return [4 /*yield*/, databaseInstance.getAll(TableName.DOCUMENT_DATA, breakVersionsDataCondition)];
                    case 6:
                        breakVersionsDataResult = _a.sent();
                        if (breakVersionsDataResult.error) {
                            // Log.error('获取breakVersionData信息失败', breakVersionsDataResult.error);
                            onFail && onFail(new Error("\u83B7\u53D6breakVersionData\u4FE1\u606F\u5931\u8D25 " + breakVersionsDataResult.error));
                            return [2 /*return*/];
                        }
                        breakVersionData = breakVersionsDataResult.data;
                        documentBreakVersions = breakVersionData
                            .map(function (item) { return _this.breakVersionDataParse(item); })
                            .filter(function (item) { return item.version > maxChunkVersion && item.version <= baseVersion; }) // 补丁逻辑 android客户端这边目前实现有问题，version是数字但是按字符串去做对比就会查不出来数据 所以只能全部查出来再对比
                            .sort(function (item1, item2) {
                            return item1.version - item2.version;
                        });
                        subDocumentBreakVersionLoadFinishTime = Date.now();
                        Log.log("\u5B50\u8868\u589E\u91CF\u7248\u672C\u6570\u636E\u8BFB\u53D6\u8017\u65F6:" + (subDocumentBreakVersionLoadFinishTime - renderSubDocumentDatFinishTime) + "ms");
                        onSuccess && onSuccess({
                            dataType: DATA_TYPE.VERSION_DATA,
                            subId: subId,
                            chunkData: documentBreakVersions,
                            isFinished: true,
                        });
                        Log.log("\u5B50\u8868\u589E\u91CF\u7248\u672C\u6570\u636E\u5E94\u7528\u8017\u65F6:" + (Date.now() - subDocumentBreakVersionLoadFinishTime) + "ms");
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 删除一个文档的缓存
     * @param secretId
     * @param uid
     */
    OfflineAPI.clearDocumentCache = function (secretId, uid) {
        return __awaiter(this, void 0, void 0, function () {
            var databaseInstance, condition, result, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getDatabaseInstance()];
                    case 1:
                        databaseInstance = (_c.sent());
                        condition = QueryCondition.newInstance()
                            .addCondition('secretId', QUERY_CONDITION_TYPE.ONLY, secretId)
                            .addCondition('uid', QUERY_CONDITION_TYPE.ONLY, uid);
                        return [4 /*yield*/, databaseInstance.delete(TableName.DOCUMENT_DATA, condition)];
                    case 2:
                        result = _c.sent();
                        _a = !result.error;
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, databaseInstance.delete(TableName.DOCUMENT_STATUS, condition)];
                    case 3:
                        _a = (result = _c.sent());
                        _c.label = 4;
                    case 4:
                        _a; // 删除status表信息
                        _b = !result.error;
                        if (!_b) return [3 /*break*/, 6];
                        return [4 /*yield*/, databaseInstance.updateField(TableName.PAD_INFO, condition, {
                                isOfflineCache: false,
                            })];
                    case 5:
                        _b = (result = _c.sent());
                        _c.label = 6;
                    case 6:
                        _b; // 更新padInfo表
                        return [2 /*return*/, result];
                }
            });
        });
    };
    OfflineAPI.breakVersionDataParse = function (item) {
        // accepted
        if (item.type === OFFLINE_ITEM_TYPE.ACCEPTED) {
            return {
                version: item.data.baseVersion,
                subId: item.data.data.subId,
                keyframe: item.data.data.keyData || undefined,
                data: item.data.data.mutations || item.data.data.changeData,
                changesetType: item.data.data.changesetType,
            };
        }
        // misschanges
        return {
            version: item.data.newVersion,
            subId: item.data.sheetId,
            data: JSON.parse(item.data.changeset),
            changesetType: item.data.changesetType,
        };
    };
    OfflineAPI.uid = getUserId();
    return OfflineAPI;
}());
export { OfflineAPI, DATA_TYPE };
//# sourceMappingURL=OfflineAPI.js.map